import type { KeyboardEvent } from 'react'

const CALENDAR_SELECTOR = '.react-datepicker'
const DAY_SELECTOR = '.react-datepicker__day'
// With monthsShown > 1, empty duplicates of neighbouring-month days also get tabindex="0" and may precede the real day in the DOM.
const PRE_SELECTED_DAY_SELECTOR = `${DAY_SELECTOR}[tabindex="0"]:not(.react-datepicker__day--outside-month)`
const DAY_NAVIGATION_KEYS = new Set(['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End'])

/**
 * Moves focus to the pre-selected day after keyboard navigation in the calendar.
 *
 * Workaround for react-datepicker < 8.2.0, which never passes `containerRef` to `Day`, so focus does not follow
 * the pre-selection. Remove after migrating react-datepicker to version 8.2.0 or later.
 */
export function focusPreSelectedDay(event: KeyboardEvent<HTMLElement>) {
  const { key, target } = event
  if (!DAY_NAVIGATION_KEYS.has(key) || !(target instanceof HTMLElement) || !target.matches(DAY_SELECTOR)) {
    return
  }

  const calendar = target.closest(CALENDAR_SELECTOR)
  if (!calendar) {
    return
  }

  // onKeyDown fires before react-datepicker updates the pre-selection, so wait until the new day is rendered.
  requestAnimationFrame(() => {
    const preSelectedDay = calendar.querySelector<HTMLElement>(PRE_SELECTED_DAY_SELECTOR)
    if (preSelectedDay && preSelectedDay !== document.activeElement) {
      preSelectedDay.focus({ preventScroll: true })
    }
  })
}
